import { DatabaseService } from 'pages/thermography/stores/DatabaseService';
import { IPlant as PowerStation } from 'pages/thermography/model/plant.model';

export interface MapMarkerPoint {
	codigo: string,
	name: string;
	code: string;
	lat: number;
	lng: number;
	startDate: string
	anomalyLevel?: number
}


export function getMapMarkerPoints(powerStations: PowerStation[]): MapMarkerPoint[] {
	return powerStations.map((powerStation: PowerStation): MapMarkerPoint => ({
		codigo: powerStation.id,
		code: powerStation.code,
		name: powerStation.name,
		lat: powerStation.latitude || 0,
		lng: powerStation.longitude || 0,
		startDate: powerStation.startDate || '',
		anomalyLevel: 1,
	}));
}
